export const manifest = (() => {
function __memo(fn) {
	let value;
	return () => value ??= (value = fn());
}

return {
	appDir: "_app",
	appPath: "_app",
	assets: new Set(["banner-bg.jpg","build/pdf.mjs","build/pdf.mjs.map","build/pdf.sandbox.mjs","build/pdf.sandbox.mjs.map","build/pdf.worker.mjs","build/pdf.worker.mjs.map","coat-of-arms.jpg","favicon.ico","fonts/optima/OptimaLTPro-Black.otf","fonts/optima/OptimaLTPro-BlackItalic.otf","fonts/optima/OptimaLTPro-Bold.otf","fonts/optima/OptimaLTPro-BoldItalic.otf","fonts/optima/OptimaLTPro-DemiBold.otf","fonts/optima/OptimaLTPro-DemiBoldItalic.otf","fonts/optima/OptimaLTPro-ExtraBlack.otf","fonts/optima/OptimaLTPro-ExtraBlackIta.otf","fonts/optima/OptimaLTPro-Italic.otf","fonts/optima/OptimaLTPro-Medium.otf","fonts/optima/OptimaLTPro-MediumItalic.otf","fonts/optima/OptimaLTPro-Roman.otf","kLawLogo.png","kLawPillers.png","kenyaLawBanner.jpg","kenyaLawFavicon.png","kenyaLawLogo.png","kenyaLawPillars.png","kl-books-bg.webp","klaw.svg","lib/turn/turn.min.js","noImage.jpg","pdf.worker.mjs","pdf.worker.mjs.br","pdf.worker.mjs.br.map","pdf.worker.mjs.gz","pdf.worker.mjs.gz.map","pdf.worker.mjs.map","pdfjs/images/altText_add.svg","pdfjs/images/altText_disclaimer.svg","pdfjs/images/altText_done.svg","pdfjs/images/altText_spinner.svg","pdfjs/images/altText_warning.svg","pdfjs/images/annotation-check.svg","pdfjs/images/annotation-comment.svg","pdfjs/images/annotation-help.svg","pdfjs/images/annotation-insert.svg","pdfjs/images/annotation-key.svg","pdfjs/images/annotation-newparagraph.svg","pdfjs/images/annotation-noicon.svg","pdfjs/images/annotation-note.svg","pdfjs/images/annotation-paperclip.svg","pdfjs/images/annotation-paragraph.svg","pdfjs/images/annotation-pushpin.svg","pdfjs/images/cursor-editorFreeHighlight.svg","pdfjs/images/cursor-editorFreeText.svg","pdfjs/images/cursor-editorInk.svg","pdfjs/images/cursor-editorTextHighlight.svg","pdfjs/images/editor-toolbar-delete.svg","pdfjs/images/editor-toolbar-edit.svg","pdfjs/images/loading-icon.gif","pdfjs/images/messageBar_closingButton.svg","pdfjs/images/messageBar_info.svg","pdfjs/images/messageBar_warning.svg","pdfjs/images/toolbarButton-editorHighlight.svg","pdfjs/images/toolbarButton-menuArrow.svg","pdfjs/pdf_viewer.css","reports/.gitkeep","samplePhoto.png","supreme-court.jpg","theJudiciary.jpeg","transparent_klaw.svg","web/cmaps/78-EUC-H.bcmap","web/cmaps/78-EUC-V.bcmap","web/cmaps/78-H.bcmap","web/cmaps/78-RKSJ-H.bcmap","web/cmaps/78-RKSJ-V.bcmap","web/cmaps/78-V.bcmap","web/cmaps/78ms-RKSJ-H.bcmap","web/cmaps/78ms-RKSJ-V.bcmap","web/cmaps/83pv-RKSJ-H.bcmap","web/cmaps/90ms-RKSJ-H.bcmap","web/cmaps/90ms-RKSJ-V.bcmap","web/cmaps/90msp-RKSJ-H.bcmap","web/cmaps/90msp-RKSJ-V.bcmap","web/cmaps/90pv-RKSJ-H.bcmap","web/cmaps/90pv-RKSJ-V.bcmap","web/cmaps/Add-H.bcmap","web/cmaps/Add-RKSJ-H.bcmap","web/cmaps/Add-RKSJ-V.bcmap","web/cmaps/Add-V.bcmap","web/cmaps/Adobe-CNS1-0.bcmap","web/cmaps/Adobe-CNS1-1.bcmap","web/cmaps/Adobe-CNS1-2.bcmap","web/cmaps/Adobe-CNS1-3.bcmap","web/cmaps/Adobe-CNS1-4.bcmap","web/cmaps/Adobe-CNS1-5.bcmap","web/cmaps/Adobe-CNS1-6.bcmap","web/cmaps/Adobe-CNS1-UCS2.bcmap","web/cmaps/Adobe-GB1-0.bcmap","web/cmaps/Adobe-GB1-1.bcmap","web/cmaps/Adobe-GB1-2.bcmap","web/cmaps/Adobe-GB1-3.bcmap","web/cmaps/Adobe-GB1-4.bcmap","web/cmaps/Adobe-GB1-5.bcmap","web/cmaps/Adobe-GB1-UCS2.bcmap","web/cmaps/Adobe-Japan1-0.bcmap","web/cmaps/Adobe-Japan1-1.bcmap","web/cmaps/Adobe-Japan1-2.bcmap","web/cmaps/Adobe-Japan1-3.bcmap","web/cmaps/Adobe-Japan1-4.bcmap","web/cmaps/Adobe-Japan1-5.bcmap","web/cmaps/Adobe-Japan1-6.bcmap","web/cmaps/Adobe-Japan1-UCS2.bcmap","web/cmaps/Adobe-Korea1-0.bcmap","web/cmaps/Adobe-Korea1-1.bcmap","web/cmaps/Adobe-Korea1-2.bcmap","web/cmaps/Adobe-Korea1-UCS2.bcmap","web/cmaps/B5-H.bcmap","web/cmaps/B5-V.bcmap","web/cmaps/B5pc-H.bcmap","web/cmaps/B5pc-V.bcmap","web/cmaps/CNS-EUC-H.bcmap","web/cmaps/CNS-EUC-V.bcmap","web/cmaps/CNS1-H.bcmap","web/cmaps/CNS1-V.bcmap","web/cmaps/CNS2-H.bcmap","web/cmaps/CNS2-V.bcmap","web/cmaps/ETHK-B5-H.bcmap","web/cmaps/ETHK-B5-V.bcmap","web/cmaps/ETen-B5-H.bcmap","web/cmaps/ETen-B5-V.bcmap","web/cmaps/ETenms-B5-H.bcmap","web/cmaps/ETenms-B5-V.bcmap","web/cmaps/EUC-H.bcmap","web/cmaps/EUC-V.bcmap","web/cmaps/Ext-H.bcmap","web/cmaps/Ext-RKSJ-H.bcmap","web/cmaps/Ext-RKSJ-V.bcmap","web/cmaps/Ext-V.bcmap","web/cmaps/GB-EUC-H.bcmap","web/cmaps/GB-EUC-V.bcmap","web/cmaps/GB-H.bcmap","web/cmaps/GB-V.bcmap","web/cmaps/GBK-EUC-H.bcmap","web/cmaps/GBK-EUC-V.bcmap","web/cmaps/GBK2K-H.bcmap","web/cmaps/GBK2K-V.bcmap","web/cmaps/GBKp-EUC-H.bcmap","web/cmaps/GBKp-EUC-V.bcmap","web/cmaps/GBT-EUC-H.bcmap","web/cmaps/GBT-EUC-V.bcmap","web/cmaps/GBT-H.bcmap","web/cmaps/GBT-V.bcmap","web/cmaps/GBTpc-EUC-H.bcmap","web/cmaps/GBTpc-EUC-V.bcmap","web/cmaps/GBpc-EUC-H.bcmap","web/cmaps/GBpc-EUC-V.bcmap","web/cmaps/H.bcmap","web/cmaps/HKdla-B5-H.bcmap","web/cmaps/HKdla-B5-V.bcmap","web/cmaps/HKdlb-B5-H.bcmap","web/cmaps/HKdlb-B5-V.bcmap","web/cmaps/HKgccs-B5-H.bcmap","web/cmaps/HKgccs-B5-V.bcmap","web/cmaps/HKm314-B5-H.bcmap","web/cmaps/HKm314-B5-V.bcmap","web/cmaps/HKm471-B5-H.bcmap","web/cmaps/HKm471-B5-V.bcmap","web/cmaps/HKscs-B5-H.bcmap","web/cmaps/HKscs-B5-V.bcmap","web/cmaps/Hankaku.bcmap","web/cmaps/Hiragana.bcmap","web/cmaps/KSC-EUC-H.bcmap","web/cmaps/KSC-EUC-V.bcmap","web/cmaps/KSC-H.bcmap","web/cmaps/KSC-Johab-H.bcmap","web/cmaps/KSC-Johab-V.bcmap","web/cmaps/KSC-V.bcmap","web/cmaps/KSCms-UHC-H.bcmap","web/cmaps/KSCms-UHC-HW-H.bcmap","web/cmaps/KSCms-UHC-HW-V.bcmap","web/cmaps/KSCms-UHC-V.bcmap","web/cmaps/KSCpc-EUC-H.bcmap","web/cmaps/KSCpc-EUC-V.bcmap","web/cmaps/Katakana.bcmap","web/cmaps/LICENSE","web/cmaps/NWP-H.bcmap","web/cmaps/NWP-V.bcmap","web/cmaps/RKSJ-H.bcmap","web/cmaps/RKSJ-V.bcmap","web/cmaps/Roman.bcmap","web/cmaps/UniCNS-UCS2-H.bcmap","web/cmaps/UniCNS-UCS2-V.bcmap","web/cmaps/UniCNS-UTF16-H.bcmap","web/cmaps/UniCNS-UTF16-V.bcmap","web/cmaps/UniCNS-UTF32-H.bcmap","web/cmaps/UniCNS-UTF32-V.bcmap","web/cmaps/UniCNS-UTF8-H.bcmap","web/cmaps/UniCNS-UTF8-V.bcmap","web/cmaps/UniGB-UCS2-H.bcmap","web/cmaps/UniGB-UCS2-V.bcmap","web/cmaps/UniGB-UTF16-H.bcmap","web/cmaps/UniGB-UTF16-V.bcmap","web/cmaps/UniGB-UTF32-H.bcmap","web/cmaps/UniGB-UTF32-V.bcmap","web/cmaps/UniGB-UTF8-H.bcmap","web/cmaps/UniGB-UTF8-V.bcmap","web/cmaps/UniJIS-UCS2-H.bcmap","web/cmaps/UniJIS-UCS2-HW-H.bcmap","web/cmaps/UniJIS-UCS2-HW-V.bcmap","web/cmaps/UniJIS-UCS2-V.bcmap","web/cmaps/UniJIS-UTF16-H.bcmap","web/cmaps/UniJIS-UTF16-V.bcmap","web/cmaps/UniJIS-UTF32-H.bcmap","web/cmaps/UniJIS-UTF32-V.bcmap","web/cmaps/UniJIS-UTF8-H.bcmap","web/cmaps/UniJIS-UTF8-V.bcmap","web/cmaps/UniJIS2004-UTF16-H.bcmap","web/cmaps/UniJIS2004-UTF16-V.bcmap","web/cmaps/UniJIS2004-UTF32-H.bcmap","web/cmaps/UniJIS2004-UTF32-V.bcmap","web/cmaps/UniJIS2004-UTF8-H.bcmap","web/cmaps/UniJIS2004-UTF8-V.bcmap","web/cmaps/UniJISPro-UCS2-HW-V.bcmap","web/cmaps/UniJISPro-UCS2-V.bcmap","web/cmaps/UniJISPro-UTF8-V.bcmap","web/cmaps/UniJISX0213-UTF32-H.bcmap","web/cmaps/UniJISX0213-UTF32-V.bcmap","web/cmaps/UniJISX02132004-UTF32-H.bcmap","web/cmaps/UniJISX02132004-UTF32-V.bcmap","web/cmaps/UniKS-UCS2-H.bcmap","web/cmaps/UniKS-UCS2-V.bcmap","web/cmaps/UniKS-UTF16-H.bcmap","web/cmaps/UniKS-UTF16-V.bcmap","web/cmaps/UniKS-UTF32-H.bcmap","web/cmaps/UniKS-UTF32-V.bcmap","web/cmaps/UniKS-UTF8-H.bcmap","web/cmaps/UniKS-UTF8-V.bcmap","web/cmaps/V.bcmap","web/cmaps/WP-Symbol.bcmap","web/compressed.tracemonkey-pldi-09.pdf","web/debugger.css","web/debugger.mjs","web/iccs/CGATS001Compat-v2-micro.icc","web/iccs/LICENSE","web/images/altText_add.svg","web/images/altText_disclaimer.svg","web/images/altText_done.svg","web/images/altText_spinner.svg","web/images/altText_warning.svg","web/images/annotation-check.svg","web/images/annotation-comment.svg","web/images/annotation-help.svg","web/images/annotation-insert.svg","web/images/annotation-key.svg","web/images/annotation-newparagraph.svg","web/images/annotation-noicon.svg","web/images/annotation-note.svg","web/images/annotation-paperclip.svg","web/images/annotation-paragraph.svg","web/images/annotation-pushpin.svg","web/images/comment-actionsButton.svg","web/images/comment-closeButton.svg","web/images/comment-editButton.svg","web/images/cursor-editorFreeHighlight.svg","web/images/cursor-editorFreeText.svg","web/images/cursor-editorInk.svg","web/images/cursor-editorTextHighlight.svg","web/images/editor-toolbar-delete.svg","web/images/editor-toolbar-edit.svg","web/images/findbarButton-next.svg","web/images/findbarButton-previous.svg","web/images/gv-toolbarButton-download.svg","web/images/loading-icon.gif","web/images/loading.svg","web/images/messageBar_closingButton.svg","web/images/messageBar_info.svg","web/images/messageBar_warning.svg","web/images/secondaryToolbarButton-documentProperties.svg","web/images/secondaryToolbarButton-firstPage.svg","web/images/secondaryToolbarButton-handTool.svg","web/images/secondaryToolbarButton-lastPage.svg","web/images/secondaryToolbarButton-rotateCcw.svg","web/images/secondaryToolbarButton-rotateCw.svg","web/images/secondaryToolbarButton-scrollHorizontal.svg","web/images/secondaryToolbarButton-scrollPage.svg","web/images/secondaryToolbarButton-scrollVertical.svg","web/images/secondaryToolbarButton-scrollWrapped.svg","web/images/secondaryToolbarButton-selectTool.svg","web/images/secondaryToolbarButton-spreadEven.svg","web/images/secondaryToolbarButton-spreadNone.svg","web/images/secondaryToolbarButton-spreadOdd.svg","web/images/toolbarButton-bookmark.svg","web/images/toolbarButton-currentOutlineItem.svg","web/images/toolbarButton-download.svg","web/images/toolbarButton-editorFreeText.svg","web/images/toolbarButton-editorHighlight.svg","web/images/toolbarButton-editorInk.svg","web/images/toolbarButton-editorSignature.svg","web/images/toolbarButton-editorStamp.svg","web/images/toolbarButton-menuArrow.svg","web/images/toolbarButton-openFile.svg","web/images/toolbarButton-pageDown.svg","web/images/toolbarButton-pageUp.svg","web/images/toolbarButton-presentationMode.svg","web/images/toolbarButton-print.svg","web/images/toolbarButton-search.svg","web/images/toolbarButton-secondaryToolbarToggle.svg","web/images/toolbarButton-sidebarToggle.svg","web/images/toolbarButton-viewAttachments.svg","web/images/toolbarButton-viewLayers.svg","web/images/toolbarButton-viewOutline.svg","web/images/toolbarButton-viewThumbnail.svg","web/images/toolbarButton-zoomIn.svg","web/images/toolbarButton-zoomOut.svg","web/images/treeitem-collapsed.svg","web/images/treeitem-expanded.svg","web/locale/ach/viewer.ftl","web/locale/af/viewer.ftl","web/locale/an/viewer.ftl","web/locale/ar/viewer.ftl","web/locale/ast/viewer.ftl","web/locale/az/viewer.ftl","web/locale/be/viewer.ftl","web/locale/bg/viewer.ftl","web/locale/bn/viewer.ftl","web/locale/bo/viewer.ftl","web/locale/br/viewer.ftl","web/locale/brx/viewer.ftl","web/locale/bs/viewer.ftl","web/locale/ca/viewer.ftl","web/locale/cak/viewer.ftl","web/locale/ckb/viewer.ftl","web/locale/cs/viewer.ftl","web/locale/cy/viewer.ftl","web/locale/da/viewer.ftl","web/locale/de/viewer.ftl","web/locale/dsb/viewer.ftl","web/locale/el/viewer.ftl","web/locale/en-CA/viewer.ftl","web/locale/en-GB/viewer.ftl","web/locale/en-US/viewer.ftl","web/locale/eo/viewer.ftl","web/locale/es-AR/viewer.ftl","web/locale/es-CL/viewer.ftl","web/locale/es-ES/viewer.ftl","web/locale/es-MX/viewer.ftl","web/locale/et/viewer.ftl","web/locale/eu/viewer.ftl","web/locale/fa/viewer.ftl","web/locale/ff/viewer.ftl","web/locale/fi/viewer.ftl","web/locale/fr/viewer.ftl","web/locale/fur/viewer.ftl","web/locale/fy-NL/viewer.ftl","web/locale/ga-IE/viewer.ftl","web/locale/gd/viewer.ftl","web/locale/gl/viewer.ftl","web/locale/gn/viewer.ftl","web/locale/gu-IN/viewer.ftl","web/locale/he/viewer.ftl","web/locale/hi-IN/viewer.ftl","web/locale/hr/viewer.ftl","web/locale/hsb/viewer.ftl","web/locale/hu/viewer.ftl","web/locale/hy-AM/viewer.ftl","web/locale/hye/viewer.ftl","web/locale/ia/viewer.ftl","web/locale/id/viewer.ftl","web/locale/is/viewer.ftl","web/locale/it/viewer.ftl","web/locale/ja/viewer.ftl","web/locale/ka/viewer.ftl","web/locale/kab/viewer.ftl","web/locale/kk/viewer.ftl","web/locale/km/viewer.ftl","web/locale/kn/viewer.ftl","web/locale/ko/viewer.ftl","web/locale/lij/viewer.ftl","web/locale/lo/viewer.ftl","web/locale/locale.json","web/locale/lt/viewer.ftl","web/locale/ltg/viewer.ftl","web/locale/lv/viewer.ftl","web/locale/meh/viewer.ftl","web/locale/mk/viewer.ftl","web/locale/ml/viewer.ftl","web/locale/mr/viewer.ftl","web/locale/ms/viewer.ftl","web/locale/my/viewer.ftl","web/locale/nb-NO/viewer.ftl","web/locale/ne-NP/viewer.ftl","web/locale/nl/viewer.ftl","web/locale/nn-NO/viewer.ftl","web/locale/oc/viewer.ftl","web/locale/pa-IN/viewer.ftl","web/locale/pl/viewer.ftl","web/locale/pt-BR/viewer.ftl","web/locale/pt-PT/viewer.ftl","web/locale/rm/viewer.ftl","web/locale/ro/viewer.ftl","web/locale/ru/viewer.ftl","web/locale/sat/viewer.ftl","web/locale/sc/viewer.ftl","web/locale/scn/viewer.ftl","web/locale/sco/viewer.ftl","web/locale/si/viewer.ftl","web/locale/sk/viewer.ftl","web/locale/skr/viewer.ftl","web/locale/sl/viewer.ftl","web/locale/son/viewer.ftl","web/locale/sq/viewer.ftl","web/locale/sr/viewer.ftl","web/locale/sv-SE/viewer.ftl","web/locale/szl/viewer.ftl","web/locale/ta/viewer.ftl","web/locale/te/viewer.ftl","web/locale/tg/viewer.ftl","web/locale/th/viewer.ftl","web/locale/tl/viewer.ftl","web/locale/tr/viewer.ftl","web/locale/trs/viewer.ftl","web/locale/uk/viewer.ftl","web/locale/ur/viewer.ftl","web/locale/uz/viewer.ftl","web/locale/vi/viewer.ftl","web/locale/wo/viewer.ftl","web/locale/xh/viewer.ftl","web/locale/zh-CN/viewer.ftl","web/locale/zh-TW/viewer.ftl","web/standard_fonts/FoxitDingbats.pfb","web/standard_fonts/FoxitFixed.pfb","web/standard_fonts/FoxitFixedBold.pfb","web/standard_fonts/FoxitFixedBoldItalic.pfb","web/standard_fonts/FoxitFixedItalic.pfb","web/standard_fonts/FoxitSerif.pfb","web/standard_fonts/FoxitSerifBold.pfb","web/standard_fonts/FoxitSerifBoldItalic.pfb","web/standard_fonts/FoxitSerifItalic.pfb","web/standard_fonts/FoxitSymbol.pfb","web/standard_fonts/LICENSE_FOXIT","web/standard_fonts/LICENSE_LIBERATION","web/standard_fonts/LiberationSans-Bold.ttf","web/standard_fonts/LiberationSans-BoldItalic.ttf","web/standard_fonts/LiberationSans-Italic.ttf","web/standard_fonts/LiberationSans-Regular.ttf","web/viewer.css","web/viewer.html","web/viewer.mjs","web/viewer.mjs.map","web/wasm/LICENSE_OPENJPEG","web/wasm/LICENSE_PDFJS_OPENJPEG","web/wasm/LICENSE_PDFJS_QCMS","web/wasm/LICENSE_QCMS","web/wasm/openjpeg.wasm","web/wasm/openjpeg_nowasm_fallback.js","web/wasm/qcms_bg.wasm"]),
	mimeTypes: {".jpg":"image/jpeg",".mjs":"text/javascript",".map":"application/json",".otf":"font/otf",".png":"image/png",".webp":"image/webp",".svg":"image/svg+xml",".js":"text/javascript",".gz":"application/gzip",".gif":"image/gif",".css":"text/css",".jpeg":"image/jpeg",".pdf":"application/pdf",".json":"application/json",".ttf":"font/ttf",".html":"text/html",".wasm":"application/wasm"},
	_: {
		client: {start:"_app/immutable/entry/start.CkscZXIT.js",app:"_app/immutable/entry/app.xs61YxZy.js",imports:["_app/immutable/entry/start.CkscZXIT.js","_app/immutable/chunks/Dvhcax_L.js","_app/immutable/chunks/Dsy9VFq4.js","_app/immutable/chunks/CnGaPG_y.js","_app/immutable/chunks/DIeogL5L.js","_app/immutable/chunks/BBilxCvN.js","_app/immutable/chunks/7JdHMB9Z.js","_app/immutable/chunks/CAN0e4T3.js","_app/immutable/entry/app.xs61YxZy.js","_app/immutable/chunks/CnGaPG_y.js","_app/immutable/chunks/DIeogL5L.js","_app/immutable/chunks/BBilxCvN.js","_app/immutable/chunks/7JdHMB9Z.js","_app/immutable/chunks/Bzak7iHL.js","_app/immutable/chunks/Dsy9VFq4.js","_app/immutable/chunks/CAN0e4T3.js","_app/immutable/chunks/BqhvobEz.js","_app/immutable/chunks/Bvo-qpfC.js","_app/immutable/chunks/DSFu6lmr.js"],stylesheets:[],fonts:[],uses_env_dynamic_public:false},
		nodes: [
			__memo(() => import('./nodes/0.js')),
			__memo(() => import('./nodes/1.js')),
			__memo(() => import('./nodes/2.js')),
			__memo(() => import('./nodes/3.js')),
			__memo(() => import('./nodes/4.js')),
			__memo(() => import('./nodes/5.js')),
			__memo(() => import('./nodes/6.js')),
			__memo(() => import('./nodes/7.js')),
			__memo(() => import('./nodes/8.js')),
			__memo(() => import('./nodes/9.js')),
			__memo(() => import('./nodes/10.js')),
			__memo(() => import('./nodes/11.js')),
			__memo(() => import('./nodes/12.js')),
			__memo(() => import('./nodes/13.js')),
			__memo(() => import('./nodes/14.js')),
			__memo(() => import('./nodes/15.js')),
			__memo(() => import('./nodes/16.js')),
			__memo(() => import('./nodes/17.js')),
			__memo(() => import('./nodes/18.js')),
			__memo(() => import('./nodes/19.js')),
			__memo(() => import('./nodes/20.js')),
			__memo(() => import('./nodes/21.js')),
			__memo(() => import('./nodes/22.js')),
			__memo(() => import('./nodes/23.js')),
			__memo(() => import('./nodes/24.js')),
			__memo(() => import('./nodes/25.js')),
			__memo(() => import('./nodes/26.js')),
			__memo(() => import('./nodes/27.js')),
			__memo(() => import('./nodes/28.js')),
			__memo(() => import('./nodes/29.js')),
			__memo(() => import('./nodes/30.js')),
			__memo(() => import('./nodes/31.js')),
			__memo(() => import('./nodes/32.js')),
			__memo(() => import('./nodes/33.js')),
			__memo(() => import('./nodes/34.js')),
			__memo(() => import('./nodes/35.js')),
			__memo(() => import('./nodes/36.js')),
			__memo(() => import('./nodes/37.js')),
			__memo(() => import('./nodes/38.js')),
			__memo(() => import('./nodes/39.js')),
			__memo(() => import('./nodes/40.js')),
			__memo(() => import('./nodes/41.js'))
		],
		remotes: {
			
		},
		routes: [
			{
				id: "/",
				pattern: /^\/$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 5 },
				endpoint: null
			},
			{
				id: "/admin/category",
				pattern: /^\/admin\/category\/?$/,
				params: [],
				page: { layouts: [0,4,], errors: [1,,], leaf: 22 },
				endpoint: null
			},
			{
				id: "/admin/category/[id=integer]",
				pattern: /^\/admin\/category\/([^/]+?)\/?$/,
				params: [{"name":"id","matcher":"integer","optional":false,"rest":false,"chained":false}],
				page: { layouts: [0,4,], errors: [1,,], leaf: 23 },
				endpoint: null
			},
			{
				id: "/admin/convenienceFee",
				pattern: /^\/admin\/convenienceFee\/?$/,
				params: [],
				page: { layouts: [0,4,], errors: [1,,], leaf: 24 },
				endpoint: null
			},
			{
				id: "/admin/legislation",
				pattern: /^\/admin\/legislation\/?$/,
				params: [],
				page: { layouts: [0,4,], errors: [1,,], leaf: 25 },
				endpoint: null
			},
			{
				id: "/admin/legislation/import",
				pattern: /^\/admin\/legislation\/import\/?$/,
				params: [],
				page: { layouts: [0,4,], errors: [1,,], leaf: 27 },
				endpoint: null
			},
			{
				id: "/admin/legislation/[id=integer]",
				pattern: /^\/admin\/legislation\/([^/]+?)\/?$/,
				params: [{"name":"id","matcher":"integer","optional":false,"rest":false,"chained":false}],
				page: { layouts: [0,4,], errors: [1,,], leaf: 26 },
				endpoint: null
			},
			{
				id: "/admin/order",
				pattern: /^\/admin\/order\/?$/,
				params: [],
				page: { layouts: [0,4,], errors: [1,,], leaf: 28 },
				endpoint: null
			},
			{
				id: "/admin/order/[id=integer]",
				pattern: /^\/admin\/order\/([^/]+?)\/?$/,
				params: [{"name":"id","matcher":"integer","optional":false,"rest":false,"chained":false}],
				page: { layouts: [0,4,], errors: [1,,], leaf: 29 },
				endpoint: null
			},
			{
				id: "/admin/product",
				pattern: /^\/admin\/product\/?$/,
				params: [],
				page: { layouts: [0,4,], errors: [1,,], leaf: 30 },
				endpoint: null
			},
			{
				id: "/admin/product/sort",
				pattern: /^\/admin\/product\/sort\/?$/,
				params: [],
				page: { layouts: [0,4,], errors: [1,,], leaf: 32 },
				endpoint: null
			},
			{
				id: "/admin/product/[id=integer]",
				pattern: /^\/admin\/product\/([^/]+?)\/?$/,
				params: [{"name":"id","matcher":"integer","optional":false,"rest":false,"chained":false}],
				page: { layouts: [0,4,], errors: [1,,], leaf: 31 },
				endpoint: null
			},
			{
				id: "/admin/profile",
				pattern: /^\/admin\/profile\/?$/,
				params: [],
				page: { layouts: [0,4,], errors: [1,,], leaf: 33 },
				endpoint: null
			},
			{
				id: "/admin/promotions",
				pattern: /^\/admin\/promotions\/?$/,
				params: [],
				page: { layouts: [0,4,], errors: [1,,], leaf: 34 },
				endpoint: null
			},
			{
				id: "/admin/reports",
				pattern: /^\/admin\/reports\/?$/,
				params: [],
				page: { layouts: [0,4,], errors: [1,,], leaf: 35 },
				endpoint: null
			},
			{
				id: "/admin/subscription",
				pattern: /^\/admin\/subscription\/?$/,
				params: [],
				page: { layouts: [0,4,], errors: [1,,], leaf: 36 },
				endpoint: null
			},
			{
				id: "/admin/users",
				pattern: /^\/admin\/users\/?$/,
				params: [],
				page: { layouts: [0,4,], errors: [1,,], leaf: 37 },
				endpoint: null
			},
			{
				id: "/admin/users/[id=integer]",
				pattern: /^\/admin\/users\/([^/]+?)\/?$/,
				params: [{"name":"id","matcher":"integer","optional":false,"rest":false,"chained":false}],
				page: { layouts: [0,4,], errors: [1,,], leaf: 38 },
				endpoint: null
			},
			{
				id: "/api/cart",
				pattern: /^\/api\/cart\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/cart/_server.ts.js'))
			},
			{
				id: "/api/document/confirm",
				pattern: /^\/api\/document\/confirm\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/document/confirm/_server.ts.js'))
			},
			{
				id: "/api/document/notification",
				pattern: /^\/api\/document\/notification\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/document/notification/_server.ts.js'))
			},
			{
				id: "/api/document/purchase",
				pattern: /^\/api\/document\/purchase\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/document/purchase/_server.ts.js'))
			},
			{
				id: "/api/image/[filename]",
				pattern: /^\/api\/image\/([^/]+?)\/?$/,
				params: [{"name":"filename","optional":false,"rest":false,"chained":false}],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/image/_filename_/_server.ts.js'))
			},
			{
				id: "/api/license",
				pattern: /^\/api\/license\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/license/_server.ts.js'))
			},
			{
				id: "/api/logout",
				pattern: /^\/api\/logout\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/logout/_server.ts.js'))
			},
			{
				id: "/api/order",
				pattern: /^\/api\/order\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/order/_server.ts.js'))
			},
			{
				id: "/api/order/notification_url",
				pattern: /^\/api\/order\/notification_url\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/order/notification_url/_server.ts.js'))
			},
			{
				id: "/api/order/validate",
				pattern: /^\/api\/order\/validate\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/order/validate/_server.ts.js'))
			},
			{
				id: "/api/order/[orderid=integer]/cancel",
				pattern: /^\/api\/order\/([^/]+?)\/cancel\/?$/,
				params: [{"name":"orderid","matcher":"integer","optional":false,"rest":false,"chained":false}],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/order/_orderid_integer_/cancel/_server.ts.js'))
			},
			{
				id: "/api/order/[orderid=integer]/product/[productid=integer]/issue",
				pattern: /^\/api\/order\/([^/]+?)\/product\/([^/]+?)\/issue\/?$/,
				params: [{"name":"orderid","matcher":"integer","optional":false,"rest":false,"chained":false},{"name":"productid","matcher":"integer","optional":false,"rest":false,"chained":false}],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/order/_orderid_integer_/product/_productid_integer_/issue/_server.ts.js'))
			},
			{
				id: "/api/page",
				pattern: /^\/api\/page\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/page/_server.ts.js'))
			},
			{
				id: "/api/product/[id=integer]",
				pattern: /^\/api\/product\/([^/]+?)\/?$/,
				params: [{"name":"id","matcher":"integer","optional":false,"rest":false,"chained":false}],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/product/_id_integer_/_server.ts.js'))
			},
			{
				id: "/api/product/[id=integer]/documents",
				pattern: /^\/api\/product\/([^/]+?)\/documents\/?$/,
				params: [{"name":"id","matcher":"integer","optional":false,"rest":false,"chained":false}],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/product/_id_integer_/documents/_server.ts.js'))
			},
			{
				id: "/api/product/[id=integer]/documents/[docId=integer]",
				pattern: /^\/api\/product\/([^/]+?)\/documents\/([^/]+?)\/?$/,
				params: [{"name":"id","matcher":"integer","optional":false,"rest":false,"chained":false},{"name":"docId","matcher":"integer","optional":false,"rest":false,"chained":false}],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/product/_id_integer_/documents/_docId_integer_/_server.ts.js'))
			},
			{
				id: "/api/product/[id=integer]/documents/[docId=integer]/stream",
				pattern: /^\/api\/product\/([^/]+?)\/documents\/([^/]+?)\/stream\/?$/,
				params: [{"name":"id","matcher":"integer","optional":false,"rest":false,"chained":false},{"name":"docId","matcher":"integer","optional":false,"rest":false,"chained":false}],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/product/_id_integer_/documents/_docId_integer_/stream/_server.ts.js'))
			},
			{
				id: "/api/product/[id=integer]/publish",
				pattern: /^\/api\/product\/([^/]+?)\/publish\/?$/,
				params: [{"name":"id","matcher":"integer","optional":false,"rest":false,"chained":false}],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/product/_id_integer_/publish/_server.ts.js'))
			},
			{
				id: "/api/reports/generate",
				pattern: /^\/api\/reports\/generate\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/reports/generate/_server.ts.js'))
			},
			{
				id: "/api/reports/publications",
				pattern: /^\/api\/reports\/publications\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/reports/publications/_server.ts.js'))
			},
			{
				id: "/api/subscription/callback/fail",
				pattern: /^\/api\/subscription\/callback\/fail\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/subscription/callback/fail/_server.ts.js'))
			},
			{
				id: "/api/subscription/callback/success",
				pattern: /^\/api\/subscription\/callback\/success\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/subscription/callback/success/_server.ts.js'))
			},
			{
				id: "/api/subscription/direct",
				pattern: /^\/api\/subscription\/direct\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/subscription/direct/_server.ts.js'))
			},
			{
				id: "/api/subscription/notification",
				pattern: /^\/api\/subscription\/notification\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/subscription/notification/_server.ts.js'))
			},
			{
				id: "/api/subscription/payment",
				pattern: /^\/api\/subscription\/payment\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/subscription/payment/_server.ts.js'))
			},
			{
				id: "/(dashboard)/checkout",
				pattern: /^\/checkout\/?$/,
				params: [],
				page: { layouts: [0,3,], errors: [1,,], leaf: 11 },
				endpoint: null
			},
			{
				id: "/favicon.ico",
				pattern: /^\/favicon\.ico\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/favicon.ico/_server.ts.js'))
			},
			{
				id: "/(Auth)/forgotPassword",
				pattern: /^\/forgotPassword\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 6 },
				endpoint: null
			},
			{
				id: "/(dashboard)/legislation",
				pattern: /^\/legislation\/?$/,
				params: [],
				page: { layouts: [0,3,], errors: [1,,], leaf: 12 },
				endpoint: null
			},
			{
				id: "/(dashboard)/legislation/[id=integer]",
				pattern: /^\/legislation\/([^/]+?)\/?$/,
				params: [{"name":"id","matcher":"integer","optional":false,"rest":false,"chained":false}],
				page: { layouts: [0,3,], errors: [1,,], leaf: 13 },
				endpoint: null
			},
			{
				id: "/(Auth)/login",
				pattern: /^\/login\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 7 },
				endpoint: null
			},
			{
				id: "/(dashboard)/product",
				pattern: /^\/product\/?$/,
				params: [],
				page: { layouts: [0,3,], errors: [1,,], leaf: 14 },
				endpoint: null
			},
			{
				id: "/(dashboard)/product/[id=integer]",
				pattern: /^\/product\/([^/]+?)\/?$/,
				params: [{"name":"id","matcher":"integer","optional":false,"rest":false,"chained":false}],
				page: { layouts: [0,3,], errors: [1,,], leaf: 15 },
				endpoint: null
			},
			{
				id: "/(dashboard)/product/[id=integer]/document/[docId=integer]",
				pattern: /^\/product\/([^/]+?)\/document\/([^/]+?)\/?$/,
				params: [{"name":"id","matcher":"integer","optional":false,"rest":false,"chained":false},{"name":"docId","matcher":"integer","optional":false,"rest":false,"chained":false}],
				page: { layouts: [0,3,], errors: [1,,], leaf: 16 },
				endpoint: null
			},
			{
				id: "/(dashboard)/profile",
				pattern: /^\/profile\/?$/,
				params: [],
				page: { layouts: [0,3,], errors: [1,,], leaf: 17 },
				endpoint: null
			},
			{
				id: "/(dashboard)/profile/subscription",
				pattern: /^\/profile\/subscription\/?$/,
				params: [],
				page: { layouts: [0,3,], errors: [1,,], leaf: 18 },
				endpoint: null
			},
			{
				id: "/(dashboard)/purchases",
				pattern: /^\/purchases\/?$/,
				params: [],
				page: { layouts: [0,3,], errors: [1,,], leaf: 19 },
				endpoint: null
			},
			{
				id: "/(dashboard)/purchases/[id=integer]",
				pattern: /^\/purchases\/([^/]+?)\/?$/,
				params: [{"name":"id","matcher":"integer","optional":false,"rest":false,"chained":false}],
				page: { layouts: [0,3,], errors: [1,,], leaf: 20 },
				endpoint: null
			},
			{
				id: "/(Auth)/register",
				pattern: /^\/register\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 8 },
				endpoint: null
			},
			{
				id: "/reports/[filename]",
				pattern: /^\/reports\/([^/]+?)\/?$/,
				params: [{"name":"filename","optional":false,"rest":false,"chained":false}],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/reports/_filename_/_server.ts.js'))
			},
			{
				id: "/(Auth)/reset-password",
				pattern: /^\/reset-password\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 9 },
				endpoint: null
			},
			{
				id: "/setup-admin",
				pattern: /^\/setup-admin\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 39 },
				endpoint: null
			},
			{
				id: "/(dashboard)/subscription",
				pattern: /^\/subscription\/?$/,
				params: [],
				page: { layouts: [0,3,], errors: [1,,], leaf: 21 },
				endpoint: null
			},
			{
				id: "/(Auth)/verify",
				pattern: /^\/verify\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 10 },
				endpoint: null
			},
			{
				id: "/view/pdf-demo",
				pattern: /^\/view\/pdf-demo\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 41 },
				endpoint: null
			},
			{
				id: "/view/[id=integer]",
				pattern: /^\/view\/([^/]+?)\/?$/,
				params: [{"name":"id","matcher":"integer","optional":false,"rest":false,"chained":false}],
				page: { layouts: [0,], errors: [1,], leaf: 40 },
				endpoint: null
			}
		],
		prerendered_routes: new Set([]),
		matchers: async () => {
			const { match: integer } = await import ('./entries/matchers/integer.js')
			return { integer };
		},
		server_assets: {}
	}
}
})();

export const prerendered = new Set([]);

export const base = "";